var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1810_890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8705 14.4502C28.8639 22.4113 22.379 28.9028 14.4439 28.8898C6.45457 28.8767 -0.0151911 22.3983 2.6791e-05 14.4263C0.0152446 6.45867 6.485 -0.0154352 14.4135 -0.000217368C22.4137 0.0150005 28.877 6.47606 28.8726 14.4502H28.8705ZM6.03934 24.4244C7.91331 21.1982 10.6677 19.3612 14.4396 19.3634C18.2071 19.3634 20.9594 21.2069 22.8333 24.4266C26.6747 21.2852 28.6074 15.7003 26.8313 10.3479C25.0443 4.95863 19.9137 1.15634 13.8504 1.38026C8.25462 1.58679 3.26534 5.58256 1.8153 11.0806C0.345689 16.6459 2.74576 21.7678 6.03934 24.4223V24.4244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4218 18.3441C11.3804 18.3246 8.94559 15.8593 8.96298 12.8157C8.98038 9.80474 11.4544 7.37206 14.4805 7.38728C17.5002 7.40467 19.9329 9.88301 19.9111 12.9222C19.8894 15.9136 17.4111 18.3637 14.424 18.3441H14.4218Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1810_890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.8704,
    height: 28.89,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.635a9c0b079cfe6f9160ae39ef6707ff.svg";
export { ForwardRef as ReactComponent };